import { createStyles, makeStyles } from "@mui/styles";
import { ReactComponent as FolderIcon } from "components/Icons/folder.svg";
import { ReactComponent as XCloseIcon } from "components/Icons/x-close.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    chips: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(0.5, 4),
      backgroundColor: theme.gray50,
      borderRadius: "4px",
      border: "1px solid #D8D8D8",
      marginRight: theme.spacing(4),
      whiteSpace: "nowrap",
    },
    closeIcon: {
      marginLeft: theme.spacing(6),
      cursor: "pointer",
      color: theme.gray500,
    },
    typeIcon: {
      marginRight: theme.spacing(4),
      color: theme.gray500,
    },
  }),
);

export type ChipsType = "default" | "catalog";

interface Props {
  type: ChipsType;
  label: string;
  onRemoveClick: () => void;
  dataTestId?: string;
}

const renderIcon = (type: ChipsType, className: string) => {
  switch (type) {
    case "catalog":
      return <FolderIcon data-role="chips" className={className} />;
    case "default":
      return null;
  }
};

export const Chips = ({ type, label, onRemoveClick, dataTestId }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.chips} data-role="chips">
      {renderIcon(type, classes.typeIcon)}
      {label}
      <XCloseIcon
        data-role="chips"
        onClick={onRemoveClick}
        className={classes.closeIcon}
        data-test-id={`${dataTestId}-delete`}
      />
    </div>
  );
};
